import { createContext, useContext, useEffect, useState } from "react";
import { UI } from "./ui";
import { COMMERCIAL_CATEGORIES, PERSONAL_CATEGORIES } from "@/data/siteData";
import policiesMr from "./policies.mr";
import policiesHi from "./policies.hi";

const LanguageContext = createContext(null);

export const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "mr", label: "मराठी" },
  { code: "hi", label: "हिंदी" },
];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("wisdom_lang") || "en");

  useEffect(() => {
    localStorage.setItem("wisdom_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => UI[lang]?.[key] ?? UI.en[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);

export function useLocalizedContent() {
  const { lang } = useLanguage();
  if (lang === "en") {
    return {
      categories: COMMERCIAL_CATEGORIES.map((c) => ({ ...c, enTitle: c.title })),
      personal: PERSONAL_CATEGORIES.map((p) => ({ ...p, enTitle: p.title })),
    };
  }
  const tr = lang === "mr" ? policiesMr : policiesHi;
  const categories = COMMERCIAL_CATEGORIES.map((cat) => {
    const tc = tr.categories?.[cat.id];
    if (!tc) return { ...cat, enTitle: cat.title };
    return {
      ...cat,
      enTitle: cat.title,
      title: tc.title || cat.title,
      blurb: tc.blurb || cat.blurb,
      intro: tc.intro || cat.intro,
      policies: cat.policies.map((p, i) => ({ ...p, ...(tc.policies?.[i] || {}) })),
    };
  });
  const personal = PERSONAL_CATEGORIES.map((p, i) => ({ ...p, enTitle: p.title, ...(tr.personal?.[i] || {}) }));
  return { categories, personal };
}
